import { API } from "@/lib/api";
import {
    BuyCostImportRequestBody,
    BuyCostImportResponse, GetUserCategoryResponse,
    GetVariableBuyCostResponse,
    VariableBuyCostBody
} from "@boxem/core-api-schema";

export const importBuyCosts = async ({ software, buyCosts }: BuyCostImportRequestBody) => {
    return API.post<BuyCostImportResponse>("/import/buy-cost", { software, buyCosts });
}

export const exportBuyCosts = async () => {
    return API.get("/export/buy-cost");
}

export const fetchVariableBuyCosts = async (listingId: number) => {
    return API.get<GetVariableBuyCostResponse>(`/buy-cost/${listingId}`);
}

export const updateVariableBuyCosts = async (listingId: number, buyCosts: VariableBuyCostBody) => {
    return API.post(`/buy-cost/${listingId}`, buyCosts);
}

export const fetchBuyCostsCategories = async () => {
    return API.get<GetUserCategoryResponse>("/buy-cost/user-categories");
}

export const convertBuyCostToFixed = async (listingId: number) => {
    return API.delete(`/buy-cost/convert-fixed/${listingId}`);
}